<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{titlePage}}
            </div>

            <div class="subtitle-1 font-weight-light">
              Заполните поля информацией о ресторане
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    :error-messages="errors['title'] || []"
                    class="purple-input"
                    v-model="data.title"
                    label="Название"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="Адресс"
                    :error-messages="errors['address'] || []"
                    class="purple-input"
                    v-model="data.address"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="Web сайт"
                    :error-messages="errors['website'] || []"
                    class="purple-input"
                    v-model="data.website"
                  />
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    class="purple-input"
                    label="Контакты"
                    :error-messages="errors['contacts'] || []"
                    v-model="data.contacts"
                  />
                </v-col>

                <v-col
                  cols="12"
                  class="text-right"
                >
                  <v-btn
                    color="success"
                    class="mr-0"
                    v-if="!loadData"
                    :loading="loading"
                    @click="create"
                  >
                    Сохранить
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <base-material-card
          class="v-card-profile"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{ user }}
            </div>
          </template>
          <v-card-text class="text-center">
            <v-switch v-model="data.isActive" label="Доступно бронирование"></v-switch>
          </v-card-text>
          <v-card-text class="text-center">
            <v-text-field
              label="Порядок сортировки"
              type="number"
              :error-messages="errors['sort_order'] || []"
              class="purple-input"
              v-model="data.sortOrder"
            />
          </v-card-text>
          <v-card-text class="text-center">
            <v-text-field
              label="Telegram Chat Id"
              :error-messages="errors['telegramChatId'] || []"
              class="purple-input"
              v-model="data.telegramChatId"
            />
          </v-card-text>
        </base-material-card>
        <base-material-card
          class="v-card-profile"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Хостес и оператор
            </div>
          </template>
          <v-card-text class="text-center">

            <v-autocomplete
              v-model="user"
              :items="items"
              hide-selected
              :loading="isLoadingSearchUser"
              :search-input.sync="searchUser"
              chips
              clearable
              @change="addUser"
              hide-details
              item-text="search"
              item-value="id"
              label="Search for a coin..."
              solo
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title>
                   Поиск пользователей
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-autocomplete>



            <v-simple-table>
              <thead>
              <tr>
                <th class="primary--text">
                  ID
                </th>
                <th class="primary--text">
                  Имя
                </th>
                <th class="primary--text">
                  Телефон
                </th>
                <th class="primary--text">

                </th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="user in users"  v-if="user" :key="user.id">
                <td>{{user.id}}</td>
                <td>{{user.first_name}} {{user.last_name}}</td>
                <td>{{user.phone_number}}</td>
                <td class="text-right">
                  <v-icon style="cursor: pointer" @click="deleteUsers(user.id)">mdi-delete-alert</v-icon>
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </base-material-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
  import store from "../../../store/store";

  export default {
    props: {
      id: {
        type: String,
        default: null
      }
    },
    created() {
      if (this.id) {
        this.loadData = true;
        bus.$emit('onProgressLinear');
        this.$store.dispatch('restaurants/getRestaurant', {
          id: this.id
        })
          .then(({data}) => {
            this.loadData = false;
            this.data.id = this.id;
            this.data.title = data.title;
            this.data.website = data.website;
            this.data.address = data.address;
            this.data.contacts = data.contacts;
            this.data.isActive = data.isActive;
            this.data.sortOrder = data.sortOrder;
            this.data.telegramChatId = data.telegramChatId;
            _.map(data.users, (user) => {
              this.users[user.id] = user;
            })
            bus.$emit('offProgressLinear');
          })
      }
    },
    data() {
      return {
        items : [],
        isLoadingSearchUser: false,
        users: [],
        loadData: false,
        errors: [],
        loading: false,
        searchUser: null,
        data: {
          id: null,
          title: '',
          website: '',
          address: '',
          contacts: '',
          isActive: '',
          telegramChatId : '',
          sortOrder: 9999
        },
      }
    },
    computed: {
      titlePage() {
        return this.id ? 'Редактировать ресторан' : 'Создать ресторан'
      },
      user() {
        return this.$store.getters['auth/loggedIn'].data.fullName;
      }
    },
    watch: {
      searchUser(value) {
        this.debounced(this.searchUsers);
      },
    },
    methods: {
      addUser(val){
        this.users[val.item.id] = val.item;
      },
      searchUsers() {
        if (this.isLoadingSearchUser) {
          return;
        }

        this.isLoadingSearchUser = true;
        axios.post('search-users', {
          query : this.searchUser
        })
        .then(({data}) => {
          data = _.map(data, (item) => {
            item.search = item.first_name + ' ' + item.last_name + '(' + item.phone_number + ')'
            item.id = {
              item : Object.assign({}, item)
            }
            return item;
          })

          this.items = data;
        })
          .finally(() => (this.isLoadingSearchUser = false))
      },
      debounced: _.debounce((cb) => {
        cb()
      }, 700),
      deleteUsers(userId) {
       this.users[userId] = null
        this.$set(this.users, userId, null)
      },
      create() {
        this.errors = [];
        if (this.loading) {
          return;
        }

        this.loading = true;

        let data = this.data;

        let users = [];

        for (var userId in this.users){
          if(this.users[userId]){
            users.push(userId);
          }
        }
        data.users = users;
        this.$store.dispatch('restaurants/createRestaurant', data)
          .then((data) => {
            this.$router.push({'name': 'restaurantEdit', params: {id: data.id}}).catch(() => {
            });
            setTimeout(() => {
              this.loading = false;
            }, 1500)
          })
          .catch(error => {
            this.loading = false;
            let response = error.response

            if (response.status == 422) {
              this.errors = response.data.errors;
            }
          })
      }
    }
  }
</script>
